<template>
  <div class="box">
    
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>
<style scoped lang="less">
.box {
  //   border: 1px solid red;
  width: 60%;
  height: 100%;
  margin: 0 auto;
  //   background: #000;
  //   background: linear-gradient(to right, #fff,#aaa);
  display: flex;
  flex-direction: column;
  // background: linear-gradient(to right, #140223, #121F45);
  color: #fff;
  // align-items: center;
  text-align: start;
}
</style>
